import {
  green,
  lightBlue,
  orange,
  pink,
  red,
  yellow,
} from '@mui/material/colors';

export const INTEGRATIONS_ANIMATED_TEXTS = [
  { text: 'Survey Monkey', color: green['300'] },
  { text: 'Appstore', color: lightBlue['A200'] },
  { text: 'Zendesk Chat', color: yellow['800'] },
  { text: 'Slack', color: pink['600'] },
  { text: 'Livechat', color: orange['700'] },
  { text: 'Playstore', color: red['300'] },
];
